// extracted by mini-css-extract-plugin
export var carrierIcon = "_v0-0";
export var carrierLogo = "_v0-1";
export var detailsSection = "_v0-2";